import { ServiceInitializer } from '@estee/elc-universal-utils';
import { BaseService } from '@estee/elc-service';

const { name, version } = __serviceInfo__;

export class CartService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    businessUnitIdParser: 'BUSINESS_UNIT_ID_PARSER',
    config: 'CART_SIDEBAR_CONFIG',
    configStore: 'CART_SIDEBAR_CONFIG_STORE',
    configRepository: 'CART_SIDEBAR_CONFIG_REPOSITORY',
    cartService: 'CART_SERVICE',
    cartSidebar: 'CART_SIDEBAR',
    cartEntity: 'CART_ENTITY',
    cartRepository: 'CART_REPOSITORY',
    recommendedItemsRepository: 'RECOMMENDED_ITEMS_REPOSITORY',
    cartSidebarViewController: 'CART_SIDEBAR_VIEW_CONTROLLER',
    recommendedItemsViewController: 'RECOMMENDED_ITEMS_VIEW_CONTROLLER',
    replenishmentViewController: 'REPLENISHMENT_VIEW_CONTROLLER',
    donationsViewController: 'DONATIONS_VIEW_CONTROLLER',
    priceFormatter: 'PRICE_FORMATTER',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    cartApiSdk: 'CART_API_SDK',
    httpTransport: 'HTTP_TRANSPORT',
    collectionRepository: 'COLLECTION_REPOSITORY',
    sentryService: 'SENTRY_SERVICE'
};
